const foodlist = {
  getlist: 'foodlist/getlist',
  add: 'foodlist/add',
  update: 'foodlist/update',
  remove: 'foodlist/remove',
  get: 'foodlist/get',
  getall: 'foodlist/getall',
}
export default foodlist
